// extracted by mini-css-extract-plugin
export default {"header":"Header_header__i4KR6","main-image":"Header_main-image__k48XZ"};